import DataGrid2 from '../../..';

export async function reload(this: DataGrid2, force?: boolean) {
	if (this.saveMode === 'self') {
		await this.__onLoad();

		return;
	}

	if (this.dataSource.name) {
		if (this.dataSource.parameters.length || force) {
			this.__dataSourceValueEntryFlag = false;
			await this.__reloadDataSource(this.dataSource, force, false, true);
		} else {
			await this.__onLoad({ reload: false, forceRefresh: force });
		}
	}
}
